module.exports = __webpack_public_path__ + "assets/img/title.3deb33c9.png";